import React, { Component, Fragment } from "react";
import "./Site.css";
import {
  Row,
  Col,
  Button,
  Table,
  ButtonGroup,
  Badge,
  ButtonDropdown,
  DropdownToggle,
  DropdownItem,
  DropdownMenu
} from "reactstrap";
import Alert from "react-s-alert";
import _ from "lodash";
import './Site.css';
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { api, filterHelper,uiHelper } from "../helpers";
import { TextFilter, SelectFilter, FilterSet, ActiveToggleFilter, Pager } from "../components";
import { Link } from "react-router-dom";
import classnames from "classnames";

const getEquipmentTypes = () => api.fetch('Reference/EquipmentTypes').then(response => {
  return {
    equipmentTypeList: _.map(response.data, x => { return { value: x.id, label: x.name }; })
  };
}).catch(x => console.error(x));
const getEquipmentStatuses = () => api.fetch('Reference/EquipmentStatus').then(response => {
  return {
    equipmentStatusList: _.map(response.data, x => { return { value: x.id, label: x.name }; })
  };
}).catch(x => console.error(x));
const getCalibrationTypes = () => api.fetch('Reference/CalibrationTypes').then(response => {
  return {
    calibrationTypeList: _.map(response.data, x => { return { value: x.id, label: x.name }; })
  };
}).catch(x => console.error(x));
const getCalibrationFrequencies = () => api.fetch('Reference/CalibrationFrequencies').then(response => {
  return {
    calibrationFrequencyList: _.map(response.data, x => { return { value: x.id, label: x.name }; })
  };
}).catch(x => console.error(x));
const getVendors = () => api.fetch('Reference/Vendors').then(response => {
  return {
    vendorList: _.map(response.data, x => { return { value: x.id, label: x.name }; })
  };
}).catch(x => console.error(x));
const getTestingMethods = () => api.fetch('Reference/TestingMethods').then(response => {
  return {
    testingMethodList: _.map(response.data, x => { return { value: x.id, label: x.name }; })
  };
}).catch(x => console.error(x));
const getLocations = () => api.fetch('Reference/Locations').then(response => {
  return {
    locationsList: _.map(response.data, x => { return { value: x.id, label: x.name }; })
  };
}).catch(x => console.error(x));

export default class Equipment extends Component {
  static displayName = Equipment.name;
  constructor(props) {
    super(props);
    this.state = {
      filters: [],
      pagedList: null,
      sortColumn: "Id",
      sortAscending: true,
      equipmentTypeList: [],
      equipmentStatusList: [],
      locationsList: [],
      calibrationTypeList: [],
      calibrationFrequencyList: [],
      vendorList: [],
      vendorMechanicList: [],
      testingMethodList: [],
      dropdownOpen: false,
      viewOnly: props.viewOnly ? props.viewOnly : false
    };

    this.refreshList = this.refreshList.bind(this);
    this.clearFilters = this.clearFilters.bind(this);
    this.onChangeFilter = this.onChangeFilter.bind(this);
    this.setPage = this.setPage.bind(this);
    this.onDismiss = this.onDismiss.bind(this);
    this.downloadReport = this.downloadReport.bind(this);
    this.toggleDropdown = this.toggleDropdown.bind(this);
  }

  componentDidMount() {
    Promise.all([getEquipmentTypes(), getEquipmentStatuses(), getCalibrationTypes(), getCalibrationFrequencies(),
    getVendors(), getTestingMethods(), getLocations()]).then(response => {
      let newStatus = {};
      _.each(response, r => Object.assign(newStatus, r));
      this.setState(newStatus, () => { 
        this.onChangeFilter({
          filterName: "activeOnly",
          value: true,
          filteredDisplay: "Active Only"
        })
      });
    });
  }

  refreshList(sortColumn, sortAscending, filters, pageNumber) {
    const resolvedFilters = filters || this.state.filters;
    const resolvedSort = {
      sortColumn: sortColumn || this.state.sortColumn,
      sortAscending: sortAscending || this.state.sortAscending
    };
    const payload = {
      activeOnly: null,
      name: null,
      ...resolvedSort,
      ...filterHelper.filtersToObject(resolvedFilters),
      pageSize: 50,
      page: pageNumber || (this.state.pagedList ? this.state.pagedList.pageNumber : 1)
    };
    api.post("Equipment/Equipments", payload)
      .then(response => {
        if (response.data) {
          this.setState({
            ...resolvedSort,
            pagedList: {
              list: response.data.dataSource,
              pageNumber: response.data.page,
              pageSize: response.data.pageSize,
              totalItems: response.data.totalItems,
              totalPages: response.data.totalPages
            },
            filters: resolvedFilters,
          });
        }
      })
  }

  setPage(page) {
    this.refreshList(null, null, null, page);
  }

  clearFilters() {
    const filters = [];
    this.setState({ filters: filters });
    this.refreshList(null, null, filters);
  }

  onChangeFilter(changedFilter) {
    const filters = filterHelper.getFilters(
      this.state.filters,
      changedFilter
    );
    this.setState({ filters: filters },
      () => {this.refreshList(null, null, filters, 1)}
    );
  }

  onDismiss() {
    this.setState({
      isMessageVisible: !this.state.isMessageVisible,
      message: null,
      messageColor: null,
    });
  }

  onDelete(id) {
    if (!window.confirm(`Are you sure you'd like to delete this equipment?`)) return;

    api.delete(`Equipment/DeleteEquipment/${id}`)
      .then(response => {
        if (response.data.success) {
          Alert.success("Equipment was deleted.")
          this.refreshList();
        } else {
          Alert.error("An error occurred. Equipment cannot be deleted at this time.")
        }
      }).catch(error => {
        Alert.error("There was an error deleting the Equipment.")
      });
  }

  onRevive(id) {
    api.post("Equipment/ReviveEquipment", id)
      .then(response => {
        if (response.data.success) {
          Alert.success("Equipment was revived.")
          this.refreshList();
        } else {
          Alert.error("An error occurred. Equipment cannot be revived at this time.")
        }
      }).catch(error => Alert.error("There was an error reviving the Equipment."));
  }

  downloadReport(isPDF) {
    const resolvedFilters = this.state.filters;
    const resolvedSort = {
      sortColumn: this.state.sortColumn,
      sortAscending: this.state.sortAscending
    };
    const payload = {
      activeOnly: null,
      name: null,
      ...resolvedSort,
      ...filterHelper.filtersToObject(resolvedFilters),
    };
    if (isPDF) {
      api.postFormDataGetBlob("Equipment/ExportPdfEquipmentList", payload)
          .then(response => {
            console.log(response, "response")
          if (response.status === 200) {
            const PDF_MIME = "application/pfd";
            const PDF_FILENAME = `Main_Equipment_List.pdf`;
            if (window.navigator && window.navigator.msSaveOrOpenBlob) {
              window.navigator.msSaveOrOpenBlob(response.data, PDF_FILENAME);
            }
            else {
              const file = new Blob([response.data], { type: PDF_MIME });
              var anchor = window.document.createElement('a');
              anchor.download = PDF_FILENAME;
              anchor.href = (window.webkitURL || window.URL).createObjectURL(file);
              anchor.dataset.downloadurl = [PDF_MIME, anchor.download, anchor.href].join(':');
              anchor.click();
            }
          } else {
            throw new Error("Error downloading report");
          }
        }).catch(error => Alert.error(error));

    } else {

      api.postFormDataGetBlob("Equipment/ExportExcelEquipmentList", payload)
        .then(response => {
          if (response.status === 200) {
            const XLSX_MIME = "application/vnd.openxmlformats-officedocument.spreadsheetml";
            const XLSX_FILENAME = `Main_Equipment_List.xlsx`;
            if (window.navigator && window.navigator.msSaveOrOpenBlob) {
              window.navigator.msSaveOrOpenBlob(response.data, XLSX_FILENAME);
            }
            else {
              const file = new Blob([response.data], { type: XLSX_MIME });
              var anchor = window.document.createElement('a');
              anchor.download = XLSX_FILENAME;
              anchor.href = (window.webkitURL || window.URL).createObjectURL(file);
              anchor.dataset.downloadurl = [XLSX_MIME, anchor.download, anchor.href].join(':');
              anchor.click();
            }
          } else {
            throw new Error("Error downloading report");
          }
        }).catch(error => Alert.error(error));
    }
  }

  toggleDropdown() {
    this.setState({ dropdownOpen: !this.state.dropdownOpen })
  }

  render() {
    const { viewOnly, dropdownOpen} = this.state;
    return (
      <div className="ml-4 mr-4">
        <Row className={classnames({ "pageTitle": viewOnly ? true : false }, "p-2")}>
          {!viewOnly ?
            <Fragment>
              <Col>
                <h5>Equipment</h5>
              </Col>
              <Col className="mr-3">
              <ButtonGroup className="float-right">
                  <ButtonDropdown
                    size="sm" title={`Download Equipment List`}
                    color="dark" className="buttonGroupSpacing float-right"
                    isOpen={dropdownOpen} toggle={this.toggleDropdown}
                    >
                    <DropdownToggle caret>
                    <FontAwesomeIcon icon="download" className="mr-2"/>
                      Download List
                    </DropdownToggle>
                    <DropdownMenu>
                      <DropdownItem onClick={()=>this.downloadReport()}>Export to Excel</DropdownItem>
                      <DropdownItem onClick={() => this.downloadReport(true)}>Export to PDF</DropdownItem>
                      </DropdownMenu>
                  </ButtonDropdown >
                <Button
                  size="sm" color="success" className="float-right"
                  tag={Link}
                  to={`/edit_equipment/new`}
                >
                    Add New Equipment
                </Button>
                </ButtonGroup>
              </Col>
            </Fragment>
            :
            <Fragment>
              <Col>
                <h4>Equipment</h4>
              </Col>
            </Fragment>
            }
        </Row>

        {viewOnly &&
          <Row className="mt-2">
            <Col>
              <ButtonDropdown
                size="sm" title={`Download Equipment List`}
                color="dark" className="buttonGroupSpacing float-right"
                isOpen={dropdownOpen} toggle={this.toggleDropdown}
              >
                <DropdownToggle caret>
                  <FontAwesomeIcon icon="download" className="mr-2" />
                      Download List
                    </DropdownToggle>
                <DropdownMenu>
                  <DropdownItem onClick={() => this.downloadReport()}>Export to Excel</DropdownItem>
                <DropdownItem onClick={() => this.downloadReport(true)}>Export to PDF</DropdownItem>
                </DropdownMenu>
              </ButtonDropdown >

            </Col>
          </Row>
        }
        <Row className="rowSpacing cursor">
          <Col>
            <FilterSet filters={this.state.filters} clearFilters={this.clearFilters} childrenClassName="pt-2 cursor pl-1 pr-1">
              <Col xs="3">
                <TextFilter
                  filterName="name"
                  displayName=" Name"
                  descriptionPrefix="contains"
                  onChangeCallback={this.onChangeFilter}
                />
              </Col>
              <Col xs="3">
                <SelectFilter
                  filterName="locationId"
                  displayName=" Location"
                  isSingleSelect={true}
                  options={this.state.locationsList}
                  onChangeCallback={this.onChangeFilter}
                  value={filterHelper.getSelectValue(
                    "locationId",
                    this.state.filters
                  )}
                />
              </Col>
              <Col xs="3">
                <SelectFilter
                  filterName="testingMethodId"
                  displayName="Testing Method"
                  isSingleSelect={true}
                  options={this.state.testingMethodList}
                  onChangeCallback={this.onChangeFilter}
                  value={filterHelper.getSelectValue(
                    "testingMethodId",
                    this.state.filters
                  )}
                />
              </Col>
              <Col xs="3">
                <SelectFilter
                  filterName="vendorId"
                  displayName="Vendor"
                  isSingleSelect={true}
                  options={this.state.vendorList}
                  onChangeCallback={this.onChangeFilter}
                  value={filterHelper.getSelectValue(
                    "vendorId",
                    this.state.filters
                  )}
                />
              </Col>
              <Col xs="3">
                <SelectFilter
                  filterName="equipmentStatusId"
                  displayName=" Equipment Status"
                  isSingleSelect={true}
                  options={this.state.equipmentStatusList}
                  onChangeCallback={this.onChangeFilter}
                  value={filterHelper.getSelectValue(
                    "equipmentStatusId",
                    this.state.filters
                  )}
                />
              </Col>
              <Col xs="2">
                <SelectFilter
                  filterName="equipmentTypeId"
                  displayName=" Equipment Type"
                  isSingleSelect={true}
                  options={this.state.equipmentTypeList}
                  onChangeCallback={this.onChangeFilter}
                  value={filterHelper.getSelectValue(
                    "equipmentTypeId",
                    this.state.filters
                  )}
                />
              </Col>
              <Col xs="2">
                <SelectFilter
                  filterName="calibrationTypeId"
                  displayName="Calibration Type"
                  isSingleSelect={true}
                  options={this.state.calibrationTypeList}
                  onChangeCallback={this.onChangeFilter}
                  value={filterHelper.getSelectValue(
                    "calibrationTypeId",
                    this.state.filters
                  )}
                />
              </Col>
              <Col xs="2">
                <SelectFilter
                  filterName="calibrationFrequencyId"
                  displayName="Calibration Frequency"
                  isSingleSelect={true}
                  options={this.state.calibrationFrequencyList}
                  onChangeCallback={this.onChangeFilter}
                  value={filterHelper.getSelectValue(
                    "calibrationFrequencyId",
                    this.state.filters
                  )}
                />
              </Col>
              <Col xs="2">
                <ActiveToggleFilter
                  filterName="requiresCalibration"
                  displayName="Requires Calibration"
                  onChangeCallback={this.onChangeFilter}
                  value={filterHelper.get_value(
                    "requiresCalibration",
                    this.state.filters
                  )}
                />
              </Col>
              <Col xs="2">
                <ActiveToggleFilter
                  filterName="activeOnly"
                  displayName="Active Only"
                  onChangeCallback={this.onChangeFilter}
                  value={filterHelper.get_value(
                    "activeOnly",
                    this.state.filters
                  )}
                />
              </Col>
            </FilterSet>
          </Col>
        </Row>

        <Row className="d-flex flex-row mt-2">
          <Col>
            <Table size="sm" responsive>
              <thead>
                <tr>
                  <th>Name</th>
                  <th>Status</th>
                  {/*<th>Description</th>*/}
                  <th>Reference Code</th>
                  <th>Equipment Type</th>
                  <th>Location</th>
                  <th></th>
                </tr>
              </thead>
              <tbody>
                {this.state.pagedList && this.state.pagedList.list.length > 0 ? (
                  this.state.pagedList.list.map(e => (
                    <tr key={e.id}>
                      <td>{e.name}</td>
                      <td><Badge color={uiHelper.resolveStatusColor(e.equipmentStatusName)}>{e.equipmentStatusName}</Badge></td>
                      {/*<td>{e.description}</td>*/}
                      <td>{e.referenceCode}</td>
                      <td>{e.equipmentTypeName}</td>
                      <td>{e.locationName}</td>
                      <td>
                        <ButtonGroup>
                          {e.deactivatedAt && !viewOnly ? (
                              <Button size="sm" className="cbdmdInfo" onClick={() => this.onRevive(e.id)}>Revive</Button>
                            ) : (
                              <React.Fragment>
                                  <Button size="sm" className="cbdmdPrimary buttonGroupSpacing"
                                    tag={Link}
                                    to={{
                                      pathname: `/edit_equipment/${e.id}`,
                                      state: { viewOnly: viewOnly },
                                      push: true,
                                    }}
                                    title={viewOnly ? "View" : "Edit"}>
                                  <FontAwesomeIcon
                                      icon={viewOnly ? "eye" : "edit"}
                                      className="ml-1 mt-0 mb-0 mr-1 pointer"
                                      title={viewOnly ? "View Details" : "Edit Details"}
                                  />
                                  </Button>
                                  {!viewOnly &&
                                    <Button size="sm" color="danger" className="cbdmdDanger buttonGroupSpacing" onClick={() => this.onDelete(e.id)} title="Delete">
                                      <FontAwesomeIcon
                                        icon="trash-alt"
                                        className="ml-1 mt-0 mb-0 mr-1 pointer "
                                        title="Delete"
                                      />
                                  </Button>
                                }
                              </React.Fragment>
                            )}
                        </ButtonGroup>
                      </td>
                    </tr>
                  ))) : (<tr>
                      <td>
                          No Records available
                      </td>
                  </tr>)}
              </tbody>
            </Table>
            <Pager {...this.state.pagedList} callBack={this.setPage} />
          </Col>
        </Row>
      </div>
    );
  }
}


// WEBPACK FOOTER //
// ./src/components/Equipment.js